import styled, { css } from 'styled-components';

import { screens } from 'ggApp/utils/mixins/screens';

export const ColumnWrapper = styled.div`
    ${({ flex }) => flex && css`
        display: flex;
    `}

    ${({ alignCenter }) => alignCenter && css`
        align-self: center;
    `}

    ${({ flexDirectionColumn }) => flexDirectionColumn && css`
        flex-direction: column;
    `}

    ${({ justifyCenter }) => justifyCenter && css`
        justify-content: center;
    `}

    ${({ summaryColumn }) => summaryColumn && css`
        border-left: 2px solid rgba(51, 51, 51, 0.07);
        align-self: stretch;
    `}

    @media (${screens.phone}) and (${screens.desktopMax}) {
        width: 100% !important;
        border-left: none !important;
    }
`;

export const RowWrapper = styled.div`
    display: flex;
    align-items: flex-start;
    position: relative;

    ${({ stretch }) => stretch && css`
        align-items: stretch;
    `}

    ${({ singleProduct }) => singleProduct && css`
        border-bottom: 2px solid rgba(51, 51, 51, 0.07);
    `}

    ${({ styledRow }) => styledRow && css`
        align-items: normal;
    `}

    ${({ multipleProducts }) => multipleProducts && css`
        border-bottom: 2px solid rgba(51, 51, 51, 0.07);
    `}

    ${({ styledRowIn }) => styledRowIn && css`
        overflow: hidden;
        height: 100%;

        > div {
            display: flex;
            position: relative;
            padding: 16px;

            &:after {
                position: absolute;
                content: ' ';
                display: block;
                width: 2px;
                top: 50%;
                left: 0;
                height: 500px;
                margin-top: -250px;
                background: rgba(51, 51, 51, 0.07);
            }

            &:nth-child(2) {
                text-align: center;
                padding-left: 0;
            }

            &:last-child {
                text-align: right;
                padding-top: 15px;
                padding-bottom: 15px;
                padding-left: 0;

                &:after {
                    display: none;
                }
            }
        }
    `}

    @media (${screens.phone}) and (${screens.desktopMax}) {
        flex-direction: column;
    }
`;
